var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import compact from "lodash/compact";
import { createRentDeposit } from "../../redux/rentDeposit/rentDeposit.actions";
import * as propertyAmenityApi from "../../reduxV2/propertyAmenity/propertyAmenity.api";
import { EContractMemberTypes, EContractType, } from "../../types/contract.types";
import { EPropertyMemberTypes } from "../../types/property.types";
import { ERentDepositProvider, } from "../../types/rentDeposit.types";
import { EField } from "./schema.createRentDeposit.types";
import { getIsProviderBanqup, getPayerForBanqup, getTenants, showInsurance, } from "./schema.createRentDeposit.utils";
export var isPerformingSubmitActionSelector = function () { return function (state) {
    return !!state.rentDeposit.isCreatingRentDeposit;
}; };
export var performingSubmitActionResultSelector = function () { return function (state) {
    return state.rentDeposit.createdRentDepositId;
}; };
export var performingSubmitActionErrorSelector = function () { return function (state) {
    return state.rentDeposit.createRentDepositError;
}; };
var findAmenityId = function (propertyAmenities, name) {
    if (!propertyAmenities)
        return undefined;
    var amenity = propertyAmenities.find(function (a) { return a.name === name; });
    return amenity === null || amenity === void 0 ? void 0 : amenity.id;
};
var createAmenityItem = function (propertyAmenities, name, value, dataType) {
    if (value === undefined || value === null)
        return null;
    return {
        id: findAmenityId(propertyAmenities, name),
        name: name,
        dataType: dataType,
        value: value,
    };
};
var AMENITY_NAMES = {
    buildingFloor: "rentio.default.building_floor",
    buildingFloorCount: "rentio.default.building_floor_count",
    roomCountBedroom: "rentio.default.room_count_bedroom",
    roomCountBathroom: "rentio.default.room_count_bathroom",
    roomCountGarage: "rentio.default.room_count_garage",
    buildingHasStorage: "rentio.default.building_has_storage",
    isFurnished: "rentio.default.is_furnished",
    hasOven: "rentio.default.has_oven",
    hasFridge: "rentio.default.has_fridge",
    hasDishwasher: "rentio.default.has_dishwasher",
    hasRangeHood: "rentio.default.has_range_hood",
    hasLift: "rentio.default.has_lift",
    hasDoubleGlazing: "rentio.default.has_double_glazing",
    hasCentralHeating: "rentio.default.has_central_heating",
    heatingType: "rentio.default.heating_type",
    buildingSurfaceArea: "rentio.default.building_surface_area",
    buildingAdjoined: "rentio.default.building_adjoined",
    buildingHasHardMaterials: "rentio.default.building_has_hard_materials",
};
export var getRentDepositValidations = function (formData, providerIsBanqup, extraData) {
    if (providerIsBanqup) {
        var payerIds = formData[EField.PayerIdentityDocuments] || [];
        var foreignersIds = formData[EField.BanqupIdentityDocuments] || [];
        var payer = getPayerForBanqup(formData, extraData);
        var isCompanyPayer_1 = !!(payer === null || payer === void 0 ? void 0 : payer.company);
        return __spreadArray(__spreadArray([], foreignersIds, true), payerIds, true).map(function (item) {
            if (item === null || item === void 0 ? void 0 : item.payerAccountId) {
                var payerItem = __assign(__assign({}, item), { accountId: item === null || item === void 0 ? void 0 : item.payerAccountId });
                if (isCompanyPayer_1) {
                    payerItem[EField.ShareholderPercentage] =
                        formData[EField.ShareholderPercentage];
                    payerItem[EField.Occupation] = formData[EField.Occupation];
                    payerItem[EField.BusinessRegisterDocument] =
                        formData[EField.BusinessRegisterDocument];
                    payerItem[EField.UboRegisterDocument] =
                        formData[EField.UboRegisterDocument];
                }
                return payerItem;
            }
            return __assign(__assign({}, item), { accountId: item === null || item === void 0 ? void 0 : item.accountId });
        });
    }
    return formData[EField.IdentityDocuments] || [];
};
export var submitActionCreator = function (extraData) { return function (formData) {
    var property = extraData.property, propertyAmenities = extraData.propertyAmenities, contract = extraData.contract, showProviderOptions = extraData.showProviderOptions, _a = extraData.hasBanqupEnabled, hasBanqupEnabled = _a === void 0 ? false : _a;
    var providerIsBanqup = showProviderOptions
        ? getIsProviderBanqup(formData[EField.Provider])
        : hasBanqupEnabled;
    var tenants = getTenants(formData, extraData);
    var broker = property.members.find(function (member) {
        return member.roles.includes(EPropertyMemberTypes.Broker);
    });
    var signers = __spreadArray([], (providerIsBanqup
        ? formData[EField.TenantSigners]
        : formData[EField.Signers] || []), true);
    var signAsBroker = formData[EField.SignAsBroker] || [];
    if (signAsBroker.length > 0) {
        signers.push(+signAsBroker[0]);
    }
    var mappedSigners = compact(signers.map(function (accountId) {
        var _a;
        if (!contract) {
            return undefined;
        }
        var contractMember = contract.members.find(function (member) { return member.account.id === accountId; });
        var roles = contractMember
            ? __spreadArray(__spreadArray([], contractMember.roles.filter(function (role) {
                return [
                    EContractMemberTypes.Tenant,
                    EContractMemberTypes.Parent,
                    EContractMemberTypes.Owner,
                ].includes(role);
            }), true), [
                EContractMemberTypes.Signer,
            ], false) : [EContractMemberTypes.Signer];
        if ((_a = formData[EField.Payer]) === null || _a === void 0 ? void 0 : _a.includes(accountId)) {
            roles.push(EContractMemberTypes.Payer);
        }
        if (tenants.length === 1 &&
            ((contractMember === null || contractMember === void 0 ? void 0 : contractMember.roles.includes(EContractMemberTypes.Tenant)) ||
                (contractMember === null || contractMember === void 0 ? void 0 : contractMember.roles.includes(EContractMemberTypes.Parent)))) {
            roles.push(EContractMemberTypes.Payer);
        }
        // Is the signer also a broker?
        var isBroker = property.members.find(function (member) {
            return member.account.id === accountId &&
                member.roles.includes(EPropertyMemberTypes.Broker);
        });
        if (isBroker) {
            roles.push(EContractMemberTypes.Broker);
        }
        return {
            roles: roles,
            accountId: accountId,
        };
    }));
    if (broker) {
        var brokerIsSigner = signers.find(function (signer) { return signer.accountId === broker.account.id; });
        if (!brokerIsSigner) {
            signers.push({
                accountId: broker.account.id,
                roles: [EContractMemberTypes.Broker],
            });
        }
    }
    var payer = providerIsBanqup
        ? getPayerForBanqup(formData, extraData)
        : undefined;
    var isCompanyPayer = !!(payer === null || payer === void 0 ? void 0 : payer.company);
    var companyKyb = isCompanyPayer
        ? {
            legalForm: formData[EField.LegalForm],
            dateOfIncorporation: formData[EField.DateOfIncorporation],
            primaryBusinessActivity: formData[EField.PrimaryBusinessActivity],
            areaOfBusinessActivities: formData[EField.AreaOfBusinessActivities],
        }
        : undefined;
    var rentDepositContract = {
        propertyId: property.id,
        relatedContractId: contract.id,
        contractType: EContractType.RentDeposit,
        startDate: formData[EField.StartDate],
        dueDate: formData[EField.DueDate],
        amount: formData[EField.Amount],
        members: mappedSigners,
        provider: providerIsBanqup
            ? ERentDepositProvider.Banqup
            : ERentDepositProvider.MangoPay,
        locale: providerIsBanqup
            ? formData[EField.Locale]
            : formData[EField.MPLocale],
        rentDepositValidations: getRentDepositValidations(formData, providerIsBanqup, extraData),
        companyKyb: companyKyb,
    };
    var requestInsurance = showInsurance(extraData) &&
        formData[EField.InsuranceSendProposal] === "yes";
    if (requestInsurance) {
        // Build amenity items for upsert to propertyAmenity
        var amenityItems = [
            createAmenityItem(propertyAmenities, AMENITY_NAMES.buildingSurfaceArea, formData[EField.InsuranceBuildingSurfaceArea], "number"),
            createAmenityItem(propertyAmenities, AMENITY_NAMES.buildingHasHardMaterials, formData[EField.InsuranceBuildingHasHardMaterials], "boolean"),
            createAmenityItem(propertyAmenities, AMENITY_NAMES.buildingAdjoined, formData[EField.InsuranceBuildingAdjoined], "string"),
            createAmenityItem(propertyAmenities, AMENITY_NAMES.buildingFloorCount, formData[EField.InsuranceBuildingLayers], "number"),
        ];
        // Filter out null items - only send changed amenities
        var newAmenityItems = amenityItems.filter(function (item) { return item !== null; });
        // Upsert only the changed amenities
        if (newAmenityItems.length > 0) {
            propertyAmenityApi.upsertForProperty(property.id, {
                amenities: newAmenityItems,
            });
        }
    }
    return createRentDeposit.actions.start({
        data: rentDepositContract,
        updatedProperty: undefined,
        requestInsurance: requestInsurance ? { contract: contract } : undefined,
    });
}; };
